import { render } from "./ForgotPasswordView.vue?vue&type=template&id=7652ca00&ts=true"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts"

import "./ForgotPasswordView.vue?vue&type=style&index=0&id=7652ca00&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__